import React, { useContext } from 'react'
import classes from './styles.module.scss'
import { ClosePopupIcon } from '../../icons/Icons'
import { styleByScreenSize } from './config'
import { WebSocketsSharedContext } from '../../integrations/WebSockets'

const StartPopup = ({
  closePopup,
  device,
  authorized,
  greeting,
  submitPopup,
}) => {
  const { initializeConversation } = useContext(WebSocketsSharedContext)
  const popupStyle = styleByScreenSize(device.width, device.height)

  const handleClosePopup = e => {
    e.stopPropagation()
    closePopup()
  }

  const handleSubmitPopup = () => {
    if (greeting?.payload && authorized) {
      const message = {
        type: 'postback',
        payload: greeting.payload,
        isRtl: false,
      }
      initializeConversation(message)
    }

    submitPopup()
  }

  return (
    <div
      className={classes.popup}
      style={popupStyle}
      onClick={handleSubmitPopup}>
      <div className={classes.closeIcon} onClick={handleClosePopup}>
        <ClosePopupIcon />
      </div>
      <p className={classes.popupText}>{greeting?.greetingText}</p>
    </div>
  )
}

export default StartPopup
